import { connect } from "react-redux";

import {
  getOfficeDetails,
  getOfficesShortList,
} from "../../OfficesNew/officesActions";
import { getOrganizationMembersList } from "../../Projects/projectsActions";
import RouteMap from "./RouteMap";
import {
  getRouteMapLocations,
  getSingleEmployeeClockInOutList,
  getTaskCheckInOutList,
} from "./routeMapActions";

const mapStateToProps = state => ({
  profile: state.profile,
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  officesShortList: state.office.officesShortList,
  officeDetails: state.office.officeDetails,
  officeDetailsLoading: state.office.isLoading,

  memberShortListIsLoading: state.project.memberShortListIsLoading,
  // loading
  locationsIsLoading: state.routeMap.locationsIsLoading,

  routeMapLocations: state.routeMap.routeMapLocations,
  clockInOutList: state.routeMap.clockInOutList,
  taskCheckInOutList: state.routeMap.taskCheckInOutList,
  filters: state.filterReducer.filters,
});

const mapDispatchToProps = dispatch => ({
  getRouteMapLocations: payload => dispatch(getRouteMapLocations(payload)),
  getOfficesShortList: payload => dispatch(getOfficesShortList(payload)),
  getOfficeDetails: payload => dispatch(getOfficeDetails(payload)),
  getOrganizationMembersList: payload =>
    dispatch(getOrganizationMembersList(payload)),
  getSingleEmployeeClockInOutList: payload =>
    dispatch(getSingleEmployeeClockInOutList(payload)),
  getTaskCheckInOutList: payload => dispatch(getTaskCheckInOutList(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteMap);
